export default {
  app: {
    name: "スポーツブック",
    full: "バックオフィステンプレート",
    minimized: "BO"
  },
  no_records: "レコードがありません",
  welcome: "{user}さん、お帰りなさい!",
  login: "アカウントにサインイン",
  login_success: "ログインに成功しました",
  relogin: "もう一度アカウントにログインしてください.",
  expired: "複数回ログインしたため、サインアウトされました!",
  denied: "アクセスが拒否されました!",
  success: "操作が成功しました!",
  select_date_range: "日付を選択してください",
  permission_denied: "この操作を行う権限がありません!",
  search_by_id_name: "IDまたは名前で検索",
  search_by_name: "名前で検索",
  close: "アカウントが閉鎖されました。管理者にお問い合わせください.",
  suspend: "アカウントが一時停止されました。管理者にお問い合わせください.",
  suspend_alert1: "アカウントが「閲覧のみ」に変更されました.",
  suspend_alert2: "アプラインに確認してください.",
  freeze: "アカウントが凍結されました。管理者にお問い合わせください.",
  account_id_length_error: "無効なアカウントIDの長さ",
  change_user_status_confirm: "アカウントのステータスを変更してもよろしいですか?",
  delete_confirm: "Aを削除してもよろしいですか \"{name}\"?",
  update_account_status_confirm: "アカウントのステータスを更新してもよろしいですか?",
  update_account_status_cancel: "アカウントのステータスの更新に失敗しました.",
  update_account_status_success: "アカウントのステータスが正常に更新されました!",
  update_account_password_confirm: "アカウントのパスワードを更新してもよろしいですか?",
  update_account_password_cancel: "アカウントのパスワードの更新に失敗しました.",
  update_account_password_success: "パスワードが正常に更新されました!",
  update_account_security_confirm: "アカウントのセキュリティを更新してもよろしいですか?",
  update_account_security_cancel: "アカウントのセキュリティの更新に失敗しました.",
  update_account_security_success: "アカウントのセキュリティが正常に更新されました!",
  update_account_authority_confirm: "アカウントの権限を更新してもよろしいです?",
  update_account_authority_cancel: "アカウントの権限の更新に失敗しました.",
  update_account_authority_success: "アカウントの権限が正常に更新されました!",
  block_sub_account_confirm: "サブアカウントをブロックしてもよろしいですか?",
  block_sub_account_cancel: "サブアカウントのブロックに失敗しました.",
  block_sub_account_success: "サブアカウントが正常にブロックされました!",
  unblock_sub_account_confirm: "サブアカウントのブロック解除をしてもよろしいですか?",
  unblock_sub_account_cancel: "サブアカウントのブロック解除に失敗しました.",
  unblock_sub_account_success: "サブアカウントが正常にブロック解除されました!",
  successful_update_profile: "プロフィールが正常に更新されました.",
  successful_update_security: "セキュリティコードが正常に更新されました.",
  successful_create_account: "新しいアカウントが正常に作成されました. ",
  update_platform_settings_confirm: "プラットフォーム設定を更新してもよろしいですか?",
  update_platform_settings_cancel: "プラットフォーム設定の更新に失敗しました.",
  update_platform_settings_success: "プラットフォーム設定が正常に更新されました!",
  reset_accumulate_win_confirm: "累積勝利制限をリセットしてもよろしいですか?",
  reset_accumulate_win_cancel: "累積勝利制限のリセットに失敗しました.",
  reset_accumulate_win_success: "累積勝利制限が正常にリセットされました!",
  parent_platform_disabled: "アプラインのプラットフォーム設定が無効化されています.",
  copy_success: "アカウント情報がクリップボードにコピーされましたd.",
  copy_failed: "お使いのブラウザはクリップボードへのコピーをサポートしていません.",
  copy_all_upline: "サッカーHDPのアプラインをすべてのスポーツタイプにコピー",
  copy_all_account: "サッカーHDPのアカウントをすべてのスポーツタイプにコピー",
  copy_all_remaining: "サッカーHDPの残りをすべてのスポーツタイプにコピー",
  copy_all_min: "サッカーHDPの最低ベット額をすべてのスポーツタイプにコピー",
  copy_all_min_bet: "サッカーの最低ベット額をすべてのスポーツタイプにコピー",
  copy_all_max_bet: "サッカーの最大ベット額をすべてのスポーツタイプにコピー",
  copy_all_max_per_match: "サッカーの試合ごとの最大ベット額をすべてのスポーツタイプにコピー",
  create_secondary_account_success: "セカンダリアカウントが正常に作成されました! 再度ログインしてください.",
  first_sub_account_success: "サブアカウントが正常に更新されました! 再度ログインしてください.",
  update_account_commission_confirm: "アカウントのコミッションを更新してもよろしいですか?",
  update_account_commission_cancel: "アカウントのコミッションの更新に失敗しました.",
  update_account_commission_success: "アカウントのコミッションが正常に更新されました!",
  update_account_position_confirm: "アカウントのポジション取りを更新してもよろしいですか?",
  update_account_position_cancel: "アカウントのポジション取りの更新に失敗しました.",
  update_account_position_success: "アカウントのポジション取りが正常に更新されました!",
  update_account_bet_limit_confirm: "アカウントのベット制限を更新してもよろしいですか?",
  update_account_bet_limit_cancel: "アカウントのベット制限の更新に失敗しました.",
  update_account_bet_limit_success: "アカウントのベット制限が正常に更新されました!",
  update_account_profile_confirm: "アカウントのプロフィールを更新してもよろしいですか?",
  update_account_profile_cancel: "アカウントのプロフィールの更新に失敗しました.",
  update_account_profile_success: "アカウントのプロフィールが正常に更新されました!",
  create_new_account_confirm: "新しいアカウントを作成してもよろしいですか?",
  create_new_account_cancel: "新しいアカウントの作成に失敗しました",
  create_new_account_success: "新しいアカウントが正常に作成されました!",
  create_sub_account_confirm: "サブアカウントを作成してもよろしいですか?",
  create_sub_account_cancel: "サブアカウントの作成に失敗しました",
  create_sub_account_success: "サブアカウントが正常に作成されました!",
  update_sub_account_confirm: "サブアカウントを更新してもよろしいですか?",
  update_sub_account_cancel: "サブアカウントの更新に失敗しました",
  update_sub_account_success: "サブアカウントが正常に更新されました!",
  unblock_account_profile_confirm: "アカウントプロフィールのブロック解除をしてもよろしいですか?",
  unblock_account_profile_cancel: "アカウントプロフィールのブロック解除に失敗しました.",
  unblock_account_profile_success: "アカウントプロフィールが正常にブロック解除されました!",
  settlement_confirm: "決済を進めてもよろしいですか?",
  settlement_cancel: "決済に失敗しました",
  settlement_success: "決済が正常に処理されました!",
  settlement_not_allowed: "今日は決済が許可されていません!",
  search_with_working_date: "稼働日で検索",
  system_error: "システムがリクエストを処理できません.",
  invalid_password: "無効なユーザー名またはパスワード.",
  invalid_account: "無効なアカウント.",
  block: "アカウントがブロックされていますd.",
  invalid_security_code: "無効なセキュリティコード.",
  source_account_id_required: "アカウントIDが必要です.",
  target_account_id_required: "ターゲットアカウントIDが必要です.",
  account_id_required: "アカウントIDが必要です.",
  sub_login_id_required: "ログインIDが必要です.",
  account_not_exists: "無効なアカウント.",
  profile_not_exists: "無効なアカウント.",
  account_inactive: "アカウントが非アクティブです.",
  not_blocked_account: "有効なアカウント.",
  password_required: "パスワードが必要です.",
  parent_id_required: "親IDが必要です.",
  parent_not_exists:"無効なアカウント.",
  invalid_account_type: "無効なアカウントタイプ.",
  account_exists: "アカウントは既に存在します.",
  login_id_required: "ログインIDが必要です.",
  new_login_id_required: "新しいログインIDが必要です.",
  login_id_not_exists: "無効なログインID.",
  invalid_authority_role: "無効な役割.",
  profile_inactive: "無効なプロフィール.",
  secondary_account_exists: "セカンダリアカウントは既に存在します.",
  new_login_id_exists: "新しいログインIDは既に存在します.",
  new_password_required: "新しいパスワードが必要です.",
  security_tag_required: "セキュリティタグが必要です.",
  security_code_required: "セキュリティコードが必要です.",
  start_date_required: "開始日が必要です.",
  end_date_required: "終了日が必要です.",
  start_date_gt_end_date: "開始日は終了日よりも大きいです.",
  start_date_greater_end_date: "開始日は終了日よりも大きいです.",
  member_id_required: "メンバーIDが必要です.",
  currency_code_required: "通貨コードが必要です.",
  commission_setting_not_exists: "コミッション設定が存在しません.",
  incomplete_account_line: "アカウントラインが不完全です.",
  invalid_hdp_package: "無効なHDPパッケージ.",
  search_id_required: "検索IDが必要です.",
  profile_id_required: "プロフィールIDが必要です.",
  login_not_exists: "無効なログインID.",
  no_changes: "変更が検出されません.",
  start_date_require: "開始日が必要です.",
  league_id_required: "リーグIDが必要です.",
  sport_type_required: "スポーツタイプが必要です.",
  match_id_required: "試合IDが必要です.",
  target_login_id_required: "ターゲットログインIDが必要です.",
  parent_account_not_exists: "無効なアカウント.",
  parent_account_inactive: "親アカウントが非アクティブです.",
  parent_profile_not_exists: "無効なアカウント.",
  parent_profile_inactive: "親プロフィールが非アクティブです.",
  target_login_id_not_exists: "無効なアカウント.",
  incorrect_parent: "無効な親ID.",
  invalid_session: "無効なセッションリクエスト.",
  session_expired: "セッションが期限切れです.",
  settle_amount_required: "決済額が必要です.",
  invalid_settle_amount: "無効な決済額.",
  settle_amount_gt_yesterday_balance: "決済額が昨日の残高よりも大きいです.",
  invalid_account_status: "無効なアカウントステータス.",
  bet_limit_packages_required: "ベット制限パッケージが必要です.",
  bet_limit_exists: "ベット制限は既に存在します.",
  member_bet_limit_package_gt_one: "メンバーベット制限パッケージが1つを超えています.",
  parent_bet_limit_not_exists: "親ベット制限が存在しません.",
  account_commission_required: "アカウントコミッションが必要です.",
  commission_setting_exists: "コミッション設定は既に存在します.",
  parent_comm_not_exists: "親コミッション設定が存在しません.",
  exceeded_parent_comm: "親コミッション設定を超えています.",
  others_commission_required: "その他のコミッション設定が必要です.",
  exceeded_parent_1x2: "親1x2コミッション設定を超えていますg.",
  exceeded_parent_other: "親その他のコミッション設定を超えています.",
  hdp_commission_required: "HDPコミッション設定が必要です.",
  exceeded_parent_hdp_a: "親のHPD(A)コミッション設定を超えました.",
  exceeded_parent_hdp_b: "親のHPD(B)コミッション設定を超えました.",
  exceeded_parent_hdp_c: "親のHPD(C)コミッション設定を超えました.",
  exceeded_parent_hdp_d: "親のHPD(D)コミッション設定を超えました.",
  exceeded_parent_hdp_e: "親のHPD(E)コミッション設定を超えました.",
  exceeded_parent_hdp_f: "親のHPD(F)コミッション設定を超えました.",
  exceeded_parent_hdp_g: "親のHPD(G)コミッション設定を超えました.",
  exceeded_parent_hdp_h: "親のHPD(H)コミッション設定を超えました.",
  exceeded_parent_hdp_i: "親のHPD(I)コミッション設定を超えました.",
  exceeded_parent_hdp_j: "親のHPD(J)コミッション設定を超えました.",
  livecasino_upline_pt_required: "[ライブカジノ] アップラインのPT設定が必要です.",
  livecasino_pt_setting_exists: "[ライブカジノ] PT設定が存在します.",
  livecasino_parent_pt_not_exists: "[ライブカジノ] 親のPT設定が存在しません.",
  livecasino_parent_min_not_meet: "[ライブカジノ] 親の最低PTと一致しません.",
  livecasino_exceeded_parent_pt: "[ライブカジノ] 親のPT設定を超えました.",
  livecasino_account_pt_required: "[ライブカジノ] アカウントのPT設定が必要です.",
  livecasino_upline_remaining_required: "[ライブカジノ] アップラインの残りPT設定が必要です.",
  livecasino_account_min_required: "[ライブカジノ] アカウントの最低PT設定が必要です.",
  livecasino_upline_remaining_gt_account_pt: "[ライブカジノ] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  livecasino_account_min_gt_p: "[ライブカジノ] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  slots_upline_pt_required: "[スロット] アップラインのPT設定が必要です.",
  slots_pt_setting_exists: "[スロット] PT設定が存在します.",
  slots_parent_pt_not_exists: "[スロット] 親のPT設定が存在しません.",
  slots_parent_min_not_meet: "[スロット] 親の最低PTと一致しません.",
  slots_exceeded_parent_pt: "[スロット] 親のPT設定を超えました.",
  slots_account_pt_required: "[スロット] アカウントのPT設定が必要です.",
  slots_upline_remaining_required: "[スロット] アップラインの残りPT設定が必要です.",
  slots_account_min_required: "[スロット] アカウントの最低PT設定が必要です.",
  slots_upline_remaining_gt_account_pt: "[スロット] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  slots_account_min_gt_pt: "[スロット] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  lotto_upline_pt_required: "[ロト] アップラインのPT設定が必要です.",
  lotto_pt_setting_exists: "[ロト] PT設定が存在します.",
  lotto_parent_pt_not_exists: "[ロト] 親のPT設定が存在しません.",
  lotto_parent_min_not_meet: "[ロト] 親の最低PTと一致しません.",
  lotto_exceeded_parent_pt: "[ロト] 親のPT設定を超えました.",
  lotto_account_pt_required: "[ロト] アカウントのPT設定が必要です.",
  lotto_upline_remaining_required: "[ロト] アップラインの残りPT設定が必要です.",
  lotto_account_min_required: "[ロト] アカウントの最低PT設定が必要です.",
  lotto_upline_remaining_gt_account_pt: "[ロト] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  lotto_account_min_gt_pt: "[ロト] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  keno_upline_pt_required: "[ケノ] アップラインのPT設定が必要です.",
  keno_pt_setting_exists: "[ケノ] PT設定が存在します.",
  keno_parent_pt_not_exists: "[ケノ] 親のPT設定が存在しません.",
  keno_parent_min_not_meet: "[ケノ] 親の最低PTと一致しません.",
  keno_exceeded_parent_pt: "[ケノ] 親のPT設定を超えました.",
  keno_account_pt_required: "[ケノ] アカウントのPT設定が必要です.",
  keno_upline_remaining_required: "[ケノ] アップラインの残りPT設定が必要です.",
  keno_account_min_required: "[ケノ] アカウントの最低PT設定が必要です.",
  keno_upline_remaining_gt_account_pt: "[ケノ] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  keno_account_min_gt_pt: "[ケノ] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  cockfight_upline_pt_required: "[ESports2] アップラインのPT設定が必要です.",
  cockfight_pt_setting_exists: "[ESports2] PT設定が存在します.",
  cockfight_parent_pt_not_exists: "[ESports2] 親のPT設定が存在しません.",
  cockfight_parent_min_not_meet: "[ESports2] 親の最低PTと一致しません.",
  cockfight_exceeded_parent_pt: "[ESports2] 親のPT設定を超えました.",
  cockfight_account_pt_required: "[ESports2] アカウントのPT設定が必要です.",
  cockfight_upline_remaining_required: "[ESports2] アップラインの残りPT設定が必要です.",
  cockfight_account_min_required: "[ESports2] アカウントの最低PT設定が必要です.",
  cockfight_upline_remaining_gt_account_pt: "[ESports2] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  cockfight_account_min_gt_pt: "[ESports2] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  cockfight_exceeded_parent_commission: "[ESports2] アカウントのコミッション設定が親のコミッション設定よりも大きいです.",
  lottery_upline_pt_required: "[ロトリー] アップラインのPT設定が必要です.",
  lottery_pt_setting_exists: "[ロトリー] PT設定が存在します.",
  lottery_parent_pt_not_exists: "[ロトリー] 親のPT設定が存在しません.",
  lottery_parent_min_not_meet: "[ロトリー] 親の最低PTと一致しません.",
  lottery_exceeded_parent_pt: "[ロトリー] 親のPT設定を超えました.",
  lottery_account_pt_required: "[ロトリー] アカウントのPT設定が必要です.",
  lottery_upline_remaining_required: "[ロトリー] アップラインの残りPT設定が必要です.",
  lottery_account_min_required: "[ロトリー] アカウントの最低PT設定が必要です.",
  lottery_upline_remaining_gt_account_pt: "[ロトリー] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  lottery_account_min_gt_pt: "[ロトリー] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  bet_type_required: "ベットタイプが必要です",
  schedule_1_to_7_required: "決済スケジュールが必要です",
  schedule_exists: "決済スケジュールが存在しません.",
  parent_schedule_not_exists: "親の決済スケジュールが存在しません.",
  schedule_1_not_available: "月曜日の決済は利用できません.",
  schedule_2_not_available: "火曜日の決済は利用できません.",
  schedule_3_not_available: "水曜日の決済は利用できませんe.",
  schedule_4_not_available: "木曜日の決済は利用できません.",
  schedule_5_not_available: "金曜日の決済は利用できません.",
  schedule_6_not_available: "土曜日の決済は利用できません.",
  schedule_7_not_available: "日曜日の決済は利用できません.",
  credit_limit_required: "クレジットリミットが必要です.",
  member_credit_limit_required: "会員のクレジット制限は必須です.",
  wallet_exists: "アカウントは既に存在します.",
  member_credit_limit_gt_credit_limit: "会員のクレジット制限がクレジット制限を超えています.",
  parent_wallet_not_exists: "アカウントが存在しません.",
  account_credit_limit_gt_parent: "アカウントのクレジット制限が親のクレジット制限を超えています.",
  member_credit_limit_gt_parent: "会員のクレジット制限が親のクレジット制限を超えています",
  exceeded_credit_limit: "アカウントのクレジット制限を超えました.",
  soccer_min_bet_required: "最低賭け金が必要です.",
  soccer_max_bet_required: "最高賭け金が必要です.",
  soccer_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  soccer_bet_limit_exists: "賭け金制限は既に存在します.",
  soccer_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  soccer_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  soccer_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  soccer_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  basketball_min_bet_required: "最低賭け金が必要です.",
  basketball_max_bet_required: "最高賭け金が必要です.",
  basketball_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  basketball_bet_limit_exists: "賭け金制限は既に存在します.",
  basketball_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  basketball_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  basketball_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  basketball_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  tennis_min_bet_required: "最低賭け金が必要です.",
  tennis_max_bet_required: "最高賭け金が必要です.",
  tennis_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  tennis_bet_limit_exists: "賭け金制限は既に存在します.",
  tennis_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  tennis_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  tennis_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  tennis_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  baseball_min_bet_required: "最低賭け金が必要です.",
  baseball_max_bet_required: "最高賭け金が必要です.",
  baseball_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  baseball_bet_limit_exists: "賭け金制限は既に存在します.",
  baseball_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  baseball_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  baseball_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  baseball_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  parlay_min_bet_required: "最低賭け金が必要です.",
  parlay_max_bet_required: "最高賭け金が必要です。.",
  parlay_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  parlay_bet_limit_exists: "賭け金制限は既に存在します.",
  parlay_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  parlay_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  parlay_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  parlay_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  esports_min_bet_required: "最低賭け金が必要です.",
  esports_max_bet_required: "最高賭け金が必要です.",
  esports_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  esports_bet_limit_exists: "賭け金制限は既に存在します.",
  esports_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  esports_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  esports_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  esports_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  others_min_bet_required: "最低賭け金が必要です.",
  others_max_bet_required: "最高賭け金が必要です.",
  others_max_per_match_required: "1試合あたりの最高賭け金が必要です",
  others_bet_limit_exists: "賭け金制限は既に存在しますs.",
  others_parent_bet_limit_not_exists: "親の賭け金制限が存在しません.",
  others_account_min_bet_lt_parent: "アカウントの最低賭け金が親より低いです.",
  others_account_max_bet_gt_parent: "アカウントの最高賭け金が親より高いです",
  others_account_max_per_match_gt_parent: "アカウントの1試合あたりの最高賭け金が親より高いです.",
  used_credit_gt_credit_limit: "使用済みクレジット制限がクレジット制限を超えています.",
  bet_limit_setting_not_exists: "賭け金制限の設定が存在しません.",
  parent_bet_limit_setting_not_exists: "親の賭け金制限の設定が存在しません.",
  package_not_exists_in_parent: "親の賭け金制限パッケージ設定が存在しません",
  soccer_bet_limit_setting_not_exists: "サッカーの賭け金制限の設定が存在しません.",
  soccer_update_interval_violated: "更新間隔に違反しました.",
  basketball_bet_limit_setting_not_exists: "バスケットボールの賭け金制限の設定が存在しません.",
  basketball_update_interval_violated: "更新間隔に違反しました.",
  tennis_bet_limit_setting_not_exists:"テニスの賭け金制限の設定が存在しません.",
  tennis_update_interval_violated: "更新間隔に違反しました.",
  baseball_bet_limit_setting_not_exists:"野球の賭け金制限の設定が存在しません.",
  baseball_update_interval_violated: "更新間隔に違反しました.",
  parlay_bet_limit_setting_not_exists:"パーレイの賭け金制限の設定が存在しません.",
  parlay_update_interval_violated: "更新間隔に違反しました.",
  esports_bet_limit_setting_not_exists:"eスポーツの賭け金制限の設定が存在しません.",
  esports_update_interval_violated: "更新間隔に違反しました.",
  others_bet_limit_setting_not_exists:"その他の賭け金制限の設定が存在しません.",
  others_update_interval_violated: "更新間隔に違反しました.",
  soccer_parent_bet_limit_setting_not_exists: "サッカーの親の賭け金制限の設定が存在しません.",
  soccer_min_bet_lt_parent: "サッカーのアカウント最低賭け金が親より低いです.",
  soccer_max_bet_gt_parent: "サッカーのアカウント最高賭け金が親より高いです.",
  soccer_max_per_match_gt_parent: "サッカーのアカウント1試合あたりの最高賭け金が親より高いです.",
  basketball_parent_bet_limit_setting_not_exists: "バスケットボールの親の賭け金制限の設定が存在しません.",
  basketball_min_bet_lt_parent: "バスケットボールアカウントの最小ベットが親のベットより低いです.",
  basketball_max_bet_gt_parent: "バスケットボールアカウントの最大ベットが親のベットより大きいです.",
  basketball_max_per_match_gt_parent: "バスケットボールアカウントの試合ごとの最大ベットが親のベットより大きいです.",
  tennis_parent_bet_limit_setting_not_exists: "テニスの親ベット制限設定が存在しません.",
  tennis_min_bet_lt_parent: "テニスアカウントの最小ベットが親のベットより低いです.",
  tennis_max_bet_gt_parent: "テニスアカウントの最大ベットが親のベットより大きいです.",
  tennis_max_per_match_gt_parent: "テニスアカウントの試合ごとの最大ベットが親のベットより大きいです.",
  baseball_parent_bet_limit_setting_not_exists: "野球の親ベット制限設定が存在しません.",
  baseball_min_bet_lt_parent: "野球アカウントの最小ベットが親のベットより低いです.",
  baseball_max_bet_gt_parent: "野球アカウントの最大ベットが親のベットより大きいです.",
  baseball_max_per_match_gt_parent: "野球アカウントの試合ごとの最大ベットが親のベットより大きいです.",
  parlay_parent_bet_limit_setting_not_exists: "パーレイの親ベット制限設定が存在しません.",
  parlay_min_bet_lt_parent: "パーレイアカウントの最小ベットが親のベットより低いです.",
  parlay_max_bet_gt_parent: "パーレイアカウントの最大ベットが親のベットより大きいです.",
  parlay_max_per_match_gt_parent: "パーレイアカウントの試合ごとの最大ベットが親のベットより大きいです.",
  esports_parent_bet_limit_setting_not_exists: "eスポーツの親ベット制限設定が存在しません.",
  esports_min_bet_lt_parent: "eスポーツアカウントの最小ベットが親のベットより低いです.",
  esports_max_bet_gt_parent: "eスポーツアカウントの最大ベットが親のベットより大きいです.",
  esports_max_per_match_gt_parent: "eスポーツアカウントの試合ごとの最大ベットが親のベットより大きいです.",
  others_parent_bet_limit_setting_not_exists: "その他の親ベット制限設定が存在しません.",
  others_min_bet_lt_parent: "その他のアカウントの最小ベットが親のベットより低いです.",
  others_max_bet_gt_parent: "その他のアカウントの最大ベットが親のベットより大きいです.",
  others_max_per_match_gt_parent: "その他のアカウントの試合ごとの最大ベットが親のベットより大きいです.",
  update_interval_violated: "更新間隔が違反しています.",
  exceeded_parent_others: "親のその他のコミッション設定を超えました.",
  exceeded_parent_hdp: "親のHDPベット制限設定を超えました.",
  no_information_available: "利用可能な情報がありません.",
  request_processing: "リクエストを処理中...",
  new_login_id_format_error: "小文字の文字と0から9の数字のみが許可されています.",
  account_id_format_error: "小文字の文字と0から9の数字のみが許可されています.",
  inactive_account: "アカウントが閉鎖/停止されました。オペレーターに連絡してください.",

  sportsbook_account_pt_gt_92: "スーパーシニアPTは92％を超えることはできません.",
  pending_result: "結果待ち",
  insufficient_balance: "残高不足",
  ok: "成功",
  settlement_warning: "警告: 残高が全額転送された場合、下記の強調表示されたメンバーは負のベットクレジットを持ち、それにより与えられたクレジットを超える可能性があります.",
  jackpot_alert: "任意の単一のプログレッシブジャックポット支払いがMYR 100,000（THB 1,000,000）を超える場合、WBETが全額を負担します.",
  accumulate_alert: "支払いが転送リストで決済されると、勝利制限がリセットされます",
  filter_yesterday_balance: "昨日の残高が0でないものを表示",

  soccer_hdp_account_pt_lt_downline: "[サッカー] HDPアカウントPTがダウンラインより低い",
  soccer_1x2_account_pt_lt_downline: "[サッカー] 1X2アカウントPTがダウンラインより低い",
  soccer_others_account_pt_lt_downline: "[サッカー] その他のアカウントPTがダウンラインより低い",
  soccer_hdp_exceeded_parent_pt: "[サッカー] 親のHDP PT設定を超えました.",
  soccer_1x2_exceeded_parent_pt: "[サッカー] 親の1X2 PT設定を超えました.",
  soccer_others_exceeded_parent_pt: "[サッカー] 親のその他のPT設定を超えました.",
  parlay_account_pt_lt_downline: "[パーレイ] アカウントPTがダウンラインより低い",
  account_pt_lt_downline: "アカウントPTがダウンラインより低い",
  player_alert_tooltips: "(注: 最低ベットよりクレジットが少ないメンバーのみ表示します。)",

  relogin_seconds: "{timer}秒後に再ログインしてください",
  relogin_hours: "{timer}時間後に再ログインしてください",
  relogin_tooltips: "アカウントのロック解除に関するサポートが必要な場合は、カスタマーサービスサポートにお問い合わせください.",
  last_modified_slot: "あなたの最後の修正時間は{oldTime}です。{newTime}にもう一度お試しください.",

  account_min_gt_pt: "アカウントの最小PT設定が親のPT設定を超えています.",
  account_min_required: "アカウントの最小PT設定が必要です.",
  account_pt_required: "アカウントPT設定が必要です.",
  agent_id_required: "エージェントIDが必要です.",
  amount_required: "金額が必要です.",
  at_least_one_schedule_required: "少なくとも1つのスケジュール設定が必要です.",
  authority_option_required: "権限オプションの設定が必要です.",

  baseball_min_bet_gt_max_bet: "野球の最小ベットが最大ベットを超えています.",
  baseball_max_bet_gt_max_per_match: "野球の最大ベットが試合ごとの最大ベットを超えています.",
  basketball_max_bet_gt_max_per_match: "バスケットボールの最大ベットが試合ごとの最大ベットを超えています.",
  basketball_min_bet_gt_max_bet: "バスケットボールの最小ベットが最大ベットを超えています.",
  brand_name_required: "ブランド名が必要です",
  client_ip_required: "クライアントIPが必要です",

  cockfight_bet_limit_exists: "[ESports2] ベット制限は既に存在します.",
  cockfight_bet_limit_packages_required: "[ESports2] ベット制限パッケージが必要です.",
  cockfight_commission_required: "[ESports2] コミッション設定が必要で.",
  cockfight_commission_setting_exists: "[ESports2] コミッション設定は既に存在します.",
  cockfight_invalid_bet_limit_package: "[ESports2] 無効なベット制限パッケージです.",
  cockfight_member_bet_limit_package_gt_one: "[ESports2] メンバーベット制限パッケージが1つ以上です.",
  cockfight_parent_bet_limit_not_exists: "[ESports2] 親のベット制限が存在しません.",
  cockfight_parent_commission_not_exists: "[ESports2] 親のコミッションが存在しません.",

  credit_limit_gt_parent_member_credit_limit: "クレジット制限が親のメンバークレジット制限を超えています.",
  downline_limit_exceeded: "ダウンラインの制限を超えました.",

  esports_max_bet_gt_max_per_match: "[ESports] 最大ベットが試合ごとの最大ベットを超えています.",
  esports_min_bet_gt_max_bet: "[ESports] 最小ベットが最大ベットを超えています.",

  exceeded_parent_parlay_a: "親のパーレイA PT設定を超えました.",
  exceeded_parent_parlay_b: "親のパーレイB PT設定を超えました.",
  exceeded_parent_pt: "親のパーレイPT設定を超えました.",

  hdp_account_min_gt_pt: "HDPアカウントの最小値が親のPTより大きいです.",
  hdp_account_min_required: "HDPアカウントの最小設定が必要です.",
  hdp_account_pt_required: "HDPアカウントPT設定が必要で.",
  hdp_exceeded_parent_commission: "HDPが親のコミッションを超えました.",
  hdp_exceeded_parent_pt: "HDPが親のPTを超えました.",
  hdp_mmo_account_min_gt_pt: "HDP MMOアカウントの最小値が親のPTより大きいです.",
  hdp_mmo_account_min_required: "HDP MMOアカウントの最小設定が必要です.",
  hdp_mmo_account_pt_required: "HDP MMOアカウントPT設定が必要です.",
  hdp_mmo_commission_required: "HDP MMOコミッションが必要です.",
  hdp_mmo_exceeded_parent_commission: "HDP MMOが親のコミッションを超えました.",
  hdp_mmo_exceeded_parent_pt: "HDP MMOが親のPTを超えました.",
  hdp_mmo_parent_min_not_meet: "HDP MMOが親の最小PTに一致しません.",
  hdp_mmo_parent_pt_not_exists: "HDP MMOの親PT設定が存在しません.",
  hdp_mmo_pt_setting_exists: "HDP MMOのPT設定は既に存在します.",
  hdp_mmo_upline_pt_required: "HDP MMOアップラインPT設定が必要ですd.",
  hdp_mmo_upline_remaining_gt_account_pt: "HDP MMOアップラインの残りのPT設定がアカウントPT設定より大きいです.",
  hdp_mmo_upline_remaining_required: "HDP MMOアップラインの残りのPT設定が必要です.",
  hdp_package_required: "HDPパッケージが必要です.",
  hdp_packages_not_exists: "HDPパッケージは存在しません.",
  hdp_packages_required: "HDPパッケージが必要です.",
  hdp_parent_min_not_meet: "HDPが親の最小PTに一致しません.",
  hdp_parent_pt_not_exists: "HDP親PT設定が存在しません.",
  hdp_pt_setting_exists: "HDP PT設定は既に存在します.",
  hdp_required: "HDPが必要です.",
  hdp_upline_pt_required: "HDPアップラインPT設定が必要です.",
  hdp_upline_remaining_gt_account_pt: "HDPアップラインの残りのPT設定がアカウントPT設定より大きいです.",
  hdp_upline_remaining_required: "HDPアップラインの残りのPT設定が必要です.",

  inactive_profile: "非アクティブなプロフィール.",
  incorrect_format: "不正な形式.",
  invalid_amount: "無効な金額.",
  invalid_baseball_max_bet: "無効な野球の最大ベット.",
  invalid_baseball_max_per_match: "無効な野球の試合ごとの最大ベット.",
  invalid_baseball_min_bet: "無効な野球の最小ベット.",
  invalid_basketball_max_bet: "無効なバスケットボールの最大ベット,",
  invalid_basketball_max_per_match: "無効なバスケットボールの試合ごとの最大ベット.",
  invalid_basketball_min_bet: "無効なバスケットボールの最小ベット.",
  invalid_esports_max_bet: "無効なeスポーツの最大ベット.",
  invalid_esports_max_per_match: "無効なeスポーツの試合ごとの最大ベット.",
  invalid_esports_min_bet: "無効なeスポーツの最小ベット.",
  invalid_method: "無効な方法.",
  invalid_others_max_bet: "無効なその他の最大ベット.",
  invalid_others_max_per_match: "無効なその他の試合ごとの最大ベット.",
  invalid_others_min_bet: "無効なその他の最小ベット.",
  invalid_parlay_max_bet: "無効なパーレイの最大ベット.",
  invalid_parlay_max_per_match: "無効なパーレイの試合ごとの最大ベット.",
  invalid_parlay_min_bet: "無効なパーレイの最小ベット.",
  invalid_soccer_max_bet: "無効なサッカーの最大ベット.",
  invalid_soccer_max_per_match: "無効なサッカーの試合ごとの最大ベット.",
  invalid_soccer_min_bet: "無効なサッカーの最小ベット.",
  invalid_tennis_max_bet: "無効なテニスの最大ベット.",
  invalid_tennis_max_per_match: "無効なテニスの試合ごとの最大ベット.",
  invalid_tennis_min_bet: "無効なテニスの最小ベット.",

  keno_bet_limit_exists: "[Keno] ベット制限は既に存在します.",
  keno_bet_limit_packages_required: "[Keno] ベット制限パッケージが必要です.",
  keno_commission_required: "[Keno] コミッション設定が必要です.",
  keno_commission_setting_exists: "[Keno] コミッション設定は既に存在します.",
  keno_exceeded_parent_commission: "[Keno] アカウントのコミッション設定が親のコミッション設定を超えています.",
  keno_invalid_bet_limit_package: "[Keno] 無効なベット制限パッケージです.",
  keno_member_bet_limit_package_gt_one: "[Keno] メンバーベット制限パッケージが1つ以上です.",
  keno_parent_bet_limit_not_exists: "[Keno] 親のベット制限が存在しません.",
  keno_parent_commission_not_exists: "[Keno] 親のコミッションが存在しません.",

  livecasino_account_min_gt_pt: "[Livecasino] アカウントの最小PT設定が親のPT設定を超えています.",
  livecasino_bet_limit_exists: "[Livecasino] ベットリミットは既に存在します.",
  livecasino_bet_limit_packages_required: "[Livecasino] ベットリミットパッケージが必要です.",
  livecasino_commission_required: "[Livecasino] コミッション設定が必要です.",
  livecasino_commission_setting_exists: "[Livecasino] コミッション設定は既に存在します.",
  livecasino_exceeded_parent_commission: "[Livecasino] アカウントのコミッション設定が親のコミッション設定を超えています.",
  livecasino_invalid_bet_limit_package: "[Livecasino] 無効なベットリミットパッケージです.",
  livecasino_member_bet_limit_package_gt_one: "[Livecasino] メンバーのベットリミットパッケージが1つ以上あります.",
  livecasino_parent_bet_limit_not_exists: "[Livecasino] 親のベットリミットが存在しません.",
  livecasino_parent_commission_not_exists: "[Livecasino] 親のコミッションが存在しません.",

  login_ip_required: "ログインIPが必要です.",
  lottery_1d_parent_min_not_meet: "[Lottery 1D] 親の最小PTに一致しません.",
  lottery_1d_account_min_gt_pt: "[Lottery 1D] アカウントの最小PT設定が親のPT設定を超えています.",
  lottery_1d_account_min_required: "[Lottery 1D] アカウントの最小PT設定が必要です.",
  lottery_1d_account_pt_lt_downline: "[Lottery 1D] アカウントPTが下線よりも低いです.",
  lottery_1d_account_pt_required: "[Lottery 1D] アカウントPT設定が必要です.",
  lottery_1d_commission_required: "[Lottery 1D] コミッション設定が必要です.",
  lottery_1d_exceeded_parent_comm: "[Lottery 1D] アカウントのコミッション設定が親のコミッション設定を超えていま.",
  lottery_1d_exceeded_parent_commission: "[Lottery 1D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_1d_exceeded_parent_pt: "[Lottery 1D] 親のPT設定を超えました.",
  lottery_1d_pt_setting_exists: "[Lottery 1D] 親のPT設定は既に存在します.",
  lottery_1d_parent_pt_not_exists: "[Lottery 1D] 親のPT設定が存在しません.",
  lottery_1d_pt_setting_not_exists: "[Lottery 1D] PT設定が存在しません.",
  lottery_1d_upline_pt_required: "[Lottery 1D] アップラインPT設定が必要です.",
  lottery_1d_upline_remaining_gt_account_pt: "[Lottery 1D] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  lottery_1d_upline_remaining_required: "[Lottery 1D] アップラインの残りのPT設定が必要です.",

  lottery_2d_account_min_gt_pt: "[Lottery 2D] アカウントの最小PT設定が親のPT設定を超えています.",
  lottery_2d_account_min_required: "[Lottery 2D] アカウントの最小PT設定が必要です.",
  lottery_2d_account_pt_lt_downline: "[Lottery 2D] アカウントPTが下線よりも低いです.",
  lottery_2d_account_pt_required: "[Lottery 2D] アカウントPT設定が必要です.",
  lottery_2d_commission_required: "[Lottery 2D] コミッション設定が必要です.",
  lottery_2d_exceeded_parent_comm: "[Lottery 2D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_2d_exceeded_parent_commission: "[Lottery 2D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_2d_exceeded_parent_pt: "[Lottery 2D] 親のPT設定を超えました.",
  lottery_2d_parent_min_not_meet: "[Lottery 2D] 親の最小PTに一致しません.",
  lottery_2d_parent_pt_not_exists: "[Lottery 2D] 親のPT設定が存在しません.",
  lottery_2d_pt_setting_exists: "[Lottery 2D] 親のPT設定は既に存在します.",
  lottery_2d_pt_setting_not_exists: "[Lottery 2D] PT設定が存在しません.",
  lottery_2d_upline_pt_required: "[Lottery 2D] アップラインPT設定が必要です.",
  lottery_2d_upline_remaining_gt_account_pt: "[Lottery 2D] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  lottery_2d_upline_remaining_required: "[Lottery 2D] アップラインの残りのPT設定が必要です.",

  lottery_3d_commission_required: "[Lottery 3D] コミッション設定が必要です.",
  lottery_3d_exceeded_parent_comm: "[Lottery 3D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_3d_exceeded_parent_commission: "[Lottery 3D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_4d_commission_required: "[Lottery 4D] コミッション設定が必要です.",
  lottery_4d_exceeded_parent_comm: "[Lottery 4D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_4d_exceeded_parent_commission: "[Lottery 4D] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lottery_bet_limit_exists: "[Lottery] ベットリミットは既に存在します.",
  lottery_bet_limit_packages_required: "[Lottery] ベットリミットパッケージが必要です.",
  lottery_commission_setting_exists: "[Lottery] コミッション設定は既に存在します.",
  lottery_invalid_bet_limit_package: "[Lottery] 無効なベットリミットパッケージです.",
  lottery_member_bet_limit_package_gt_one: "[Lottery] メンバーのベットリミットパッケージが1つ以上あります.",
  lottery_parent_bet_limit_not_exists: "[Lottery] 親のベットリミットが存在しません.",
  lottery_parent_commission_not_exists: "[Lottery] 親のコミッションが存在しません.",

  lotto_bet_limit_exists: "[Lotto] ベットリミットは既に存在します.",
  lotto_bet_limit_packages_required: "[Lotto] ベットリミットパッケージが必要です.",
  lotto_commission_required: "[Lotto] コミッション設定が必要です.",
  lotto_commission_setting_exists: "[Lotto] コミッション設定は既に存在します.",
  lotto_exceeded_parent_commission: "[Lotto] アカウントのコミッション設定が親のコミッション設定を超えています.",
  lotto_invalid_bet_limit_package: "[Lotto] 無効なベットリミットパッケージです.",
  lotto_member_bet_limit_package_gt_one: "[Lotto] メンバーのベットリミットパッケージが1つ以上あります.",
  lotto_parent_bet_limit_not_exists: "[Lotto] 親のベットリミットが存在しません.",
  lotto_parent_commission_not_exists: "[Lotto] 親のコミッションが存在しません.",

  method_required: "メソッドが必要です.",
  no_accumulate_win: "累積勝利なし.",

  one_x_two_account_min_gt_pt: "[1X2] アカウントの最小PT設定が親のPT設定を超えています.",
  one_x_two_account_min_required: "[1X2] アカウントの最小PT設定が必要です.",
  one_x_two_account_pt_required: "[1X2] アカウントPT設定が必要です.",
  one_x_two_commission_required: "[1X2] コミッション設定が必要です.",
  one_x_two_exceeded_parent_commission: "[1X2] アカウントのコミッション設定が親のコミッション設定を超えています.",
  one_x_two_exceeded_parent_pt: "[1X2] 親のPT設定を超えました.",
  one_x_two_parent_min_not_meet: "[1X2] 親の最小PTに一致しません.",
  one_x_two_parent_pt_not_exists: "[1X2] 親のPT設定が存在しません.",
  one_x_two_pt_setting_exists: "[1X2] PT設定が既に存在します.",
  one_x_two_upline_pt_required: "[1X2] アップラインPT設定が必要です.",
  one_x_two_upline_remaining_gt_account_pt: "[1X2] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  one_x_two_upline_remaining_required: "[1X2] アップラインの残りのPT設定が必要です.",

  others_account_min_gt_pt: "[Others] アカウントの最小PT設定が親のPT設定を超えています.",
  others_account_min_required: "[Others] アカウントの最小PT設定が必要です.",
  others_account_pt_required: "[Others] アカウントPT設定が必要です.",
  others_exceeded_parent_commission: "[Others] アカウントのコミッション設定が親のコミッション設定を超えていま.",
  others_exceeded_parent_pt: "[Others] 親のPT設定を超えました.",
  others_max_bet_gt_max_per_match: "[Others] 最大ベット額が試合ごとの最大値を超えています,",
  others_min_bet_gt_max_bet: "[Others] 最小ベット額が最大ベット額を超えています.",
  others_parent_min_not_meet: "[Others] 親の最小PTに一致しません.",
  others_parent_pt_not_exists: "[Others] 親のPT設定が存在しません.",
  others_pt_setting_exists: "[Others] PT設定が既に存在します.",
  others_upline_pt_required: "[Others] アップラインPT設定が必要です.",
  others_upline_remaining_gt_account_pt: "[Others] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  others_upline_remaining_required: "[Others] アップラインの残りのPT設定が必要です.",

  parent_hdp_packages_not_exists: "親のHDPパッケージが存在しません.",
  parent_pt_not_exists: "親のPT設定が存在しません.",
  parent_setting_not_exists: "PT設定が存在しません.",
  parlay_a_commission_required: "[Parlay A] コミッション設定が必要です.",
  parlay_a_exceeded_parent_commission: "[Parlay A] アカウントのコミッション設定が親のコミッション設定を超えています.",
  parlay_a_required: "[Parlay A] 設定が必要です.",
  parlay_account_min_gt_pt: "[Parlay] アカウントの最小PT設定が親のPT設定を超えています.",
  parlay_account_min_required: "[Parlay] アカウントの最小PT設定が必要です.",
  parlay_account_pt_required: "[Parlay] アカウントのPT設定が必要です.",
  parlay_b_commission_required: "[Parlay B] コミッション設定が必要です.",
  parlay_b_exceeded_parent_commission: "[Parlay B] アカウントのコミッション設定が親のコミッション設定を超えています.",
  parlay_b_required: "[Parlay B] 設定が必要です.",
  parlay_exceeded_parent_pt: "[Parlay] 親のPT設定を超えました.",
  parlay_max_bet_gt_max_per_match: "[Parlay] 最大ベットが試合ごとの最大ベットを超えています.",
  parlay_min_bet_gt_max_bet: "[Parlay] 最小ベットが最大ベットを超えています.",
  parlay_mmo_account_min_gt_pt: "[Parlay MMO] アカウントの最小PT設定が親のPT設定を超えています.",
  parlay_mmo_account_min_required: "[Parlay MMO] アカウントの最小PT設定が必要です.",
  parlay_mmo_account_pt_required: "[Parlay MMO] アカウントのPT設定が必要です.",
  parlay_mmo_exceeded_parent_pt: "[Parlay MMO] 親のPT設定を超えました.",
  parlay_mmo_parent_min_not_meet: "[Parlay MMO] 親の最小PTに一致しません.",
  parlay_mmo_parent_pt_not_exists: "[Parlay MMO] 親のPT設定が存在しません.",
  parlay_mmo_pt_setting_exists: "[Parlay MMO] PT設定は既に存在します。.",
  parlay_mmo_upline_pt_required: "[Parlay MMO] アップラインPT設定が必要です.",
  parlay_mmo_upline_remaining_gt_account_pt: "[Parlay MMO] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  parlay_mmo_upline_remaining_required: "[Parlay MMO] アップラインの残りのPT設定が必要です.",
  parlay_parent_min_not_meet: "[Parlay] 親の最小PTに一致しません.",
  parlay_parent_pt_not_exists: "[Parlay] 親のPT設定が存在しません.",
  parlay_pt_setting_exists: "[Parlay] PT設定は既に存在します.",
  parlay_pt_setting_not_exists: "[Parlay] PT設定が存在しません.",
  parlay_upline_pt_required: "[Parlay] アップラインPT設定が必要です.",
  parlay_upline_remaining_gt_account_pt: "[Parlay] アップラインの残りのPT設定がアカウントPT設定より大きいで.",
  parlay_upline_remaining_required: "[Parlay] アップラインの残りのPT設定が必要です.",
  platform_code_required: "プラットフォームコードが必要です.",
  platform_name_required: "プラットフォーム名が必要です.",
  pt_setting_not_exists: "PT設定が存在しません.",

  result_id_required: "結果IDが必要です.",
  schedule_not_exists: "スケジュールが存在しません.",

  slots_commission_required: "[Slots] コミッション設定が必要です.",
  slots_commission_setting_exists: "[Slots] コミッション設定は既に存在します.",
  slots_exceeded_parent_commission: "[Slots] アカウントのコミッション設定が親のコミッション設定を超えています.",
  slots_parent_commission_not_exists: "[Slots] 親のコミッションが存在しません.",

  soccer_1x2_account_min_gt_pt: "[1X2] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  soccer_1x2_account_min_required: "[1X2] アカウントの最低PT設定が必要です.",
  soccer_1x2_account_pt_required: "[1X2] アカウントのPT設定が必要です.",
  soccer_1x2_parent_pt_not_exists: "[1X2] 親のPT設定が存在しません.",
  soccer_1x2_pt_setting_not_exists: "[1X2] PT設定が存在しません.",
  soccer_1x2_upline_pt_required: "[1X2] アップラインのPT設定が必要です.",
  soccer_1x2_upline_remaining_gt_account_pt: "[1X2] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  soccer_1x2_upline_remaining_required: "[1X2] アップラインの残りPT設定が必要です.",
  soccer_hdp_account_min_gt_pt: "[HDP] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  soccer_hdp_account_min_required: "[HDP] アカウントの最低PT設定が必要です.",
  soccer_hdp_account_pt_required: "[HDP] アカウントのPT設定が必要です.",
  soccer_hdp_parent_pt_not_exists: "[HDP] 親のPT設定が存在しません.",
  soccer_hdp_pt_setting_not_exists: "[HDP] PT設定が存在しません.",
  soccer_hdp_upline_pt_required: "[HDP] アップラインのPT設定が必要です.",
  soccer_hdp_upline_remaining_gt_account_pt: "[HDP] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  soccer_hdp_upline_remaining_required: "[HDP] アップラインの残りPT設定が必要です.",
  soccer_max_bet_gt_max_per_match: "[サッカー] 最大ベットが試合ごとの最大ベットよりも大きいです.",
  soccer_min_bet_gt_max_bet: "[サッカー] 最低ベットが最大ベットよりも大きいです.",
  soccer_others_account_min_gt_pt: "[その他] アカウントの最低PT設定が親のPT設定よりも大きいです.",
  soccer_others_account_min_required: "[その他] アカウントの最低PT設定が必要です.",
  soccer_others_account_pt_required: "[その他] アカウントのPT設定が必要です.",
  soccer_others_parent_pt_not_exists: "[その他] 親のPT設定が存在しません.",
  soccer_others_pt_setting_not_exists: "[その他] PT設定が存在しません.",
  soccer_others_upline_pt_required: "[その他] アップラインのPT設定が必要です.",
  soccer_others_upline_remaining_gt_account_pt: "[その他] アップラインの残りPT設定がアカウントのPT設定よりも大きいです.",
  soccer_others_upline_remaining_required: "[その他] アップラインの残りPT設定が必要です.",

  sportsbook_commission_setting_exists: "[スポーツブック] コミッション設定が存在します.",
  sportsbook_mmo_commission_setting_exists: "[スポーツブック MMO] コミッション設定が存在します.",
  sportsbook_mmo_parent_commission_not_exists: "[スポーツブック MMO] 親のコミッション設定が存在しません.",
  sportsbook_parent_commission_not_exists: "[スポーツブック] 親のコミッション設定が存在しません.",
  status_required: "ステータスが必要です.",
  sub_not_exists: "サブアカウントが存在しません.",

  target_profile_id_required: "ターゲットプロフィールIDが必要です.",
  tennis_max_bet_gt_max_per_match: "[テニス] 最大ベットが試合ごとの最大ベットよりも大きいです.",
  tennis_min_bet_gt_max_bet: "[テニス] 最低ベットが最大ベットよりも大きいです.",
  tournament_commission_required: "トーナメントコミッションが必要です.",
  tournament_commission_setting_exists: "トーナメントコミッション設定が存在します.",
  tournament_exceeded_parent_commission: "トーナメントの親コミッションを超えています.",
  tournament_parent_commission_not_exists: "トーナメントの親コミッションが存在しません.",

  upline_pt_required: "アップラインのPT設定が必要です.",
  upline_remaining_gt_account_pt: "アップラインの残りPT設定がアカウントのPT設定よりも大きいで.",
  upline_remaining_required: "アップラインの残りPT設定が必要です.",
  wallet_not_exists: "ウォレットが存在しません.",
  working_date_required: "稼働日が必要です.",
  password_expired_alert: "パスワードが期限切れです。パスワードをリセットしてください.",

  cs_min_bet_lt_soccer: "最低ベットがサッカーの最低ベットよりも低いです.",
  cs_max_bet_gt_soccer: "最大ベットがサッカーの最大ベットよりも大きいです.",
  cs_max_per_match_gt_soccer: "試合ごとの最大ベットがサッカーの試合ごとの最大ベットよりも大きいです.",
  cs_tooltips: "正確なスコアのベット制限はサッカーのベット制限にのみ準拠します",

  contact_phone_format_error: "無効な連絡電話番号の形式です",
  contact_email_format_error: "無効な連絡メールアドレスの形式です",

  "notice": "<div style='text-align: left;'><b><u>通知: Evolution Casinoのベット制限に関する更新</u></b><br><br>尊敬するエージェントの皆様へ,<br><br>2025年1月31日より、<b>Evolution Casinoは企業が課すベット制限をサポートしなくなります</b>。この変更により、プラットフォームはベット金額を制限せず、より柔軟な運用が可能になります。<br><br>この変更に適応するため、ご理解と引き続きのご協力をお願いいたします。ご質問がある場合は、サポートチームまでお気軽にお問い合わせください。<br><br>ご協力いただきありがとうございます。</div>"
};
